export default {
  controls: [
    {
      title: 'controls.folding_of_middle_siderails',
      icon: 'icon-postranice',
      animation: 'folding_of_foot_siderails',
      autoHideLabel: true,
      checkTransferMode: true,
      toggle: true
    },
    {
      title: 'controls.folding_of_head_siderails',
      icon: 'icon-head-siderails',
      animation: 'folding_of_head_siderails',
      autoHideLabel: true,
      toggle: true
    },
    {
      title: 'controls.mobilift',
      icon: 'icon-mobilift',
      animation: 'mobi_lift_handle',
      autoHideLabel: true,
      toggle: true
    }
  ],
  solutions: [
    {
      title: 'Early mobilization',
      style: 'thumbnails',
      image: 'solution--early-mobilization.jpg',
      explanation: 'early_mobilization',
      wide: true
    },
    {
      title: 'Safe patient moving and handling',
      style: 'thumbnails',
      image: 'solution--safe-patient-moving-and-handling.jpg',
      explanation: 'safe_patient_moving_and_handling',
      wide: true
    },
    {
      title: 'Pressure injury prevention',
      style: 'thumbnails',
      image: 'solution--pressure-injury-prevention.jpg',
      explanation: 'pressure_injury_prevention',
      wide: true
    },
    {
      title: 'Falls prevention',
      style: 'thumbnails',
      image: 'solution--falls-prevention.jpg',
      explanation: 'falls_prevention',
      wide: true
    },
    {
      title: 'Improve patient experience',
      style: 'thumbnails',
      image: 'solution--improve-patient-experience.jpg',
      explanation: 'improve_patient_experience',
      wide: true
    }
  ],
  keyFeatures: [
    {
      title: 'key_features.safety',
      style: 'thumbnails',
      image: 'key_features--safety.png',
      explanation: 'safety',
    },
    {
      title: 'key_features.mobilization',
      style: 'thumbnails',
      image: 'key_features--mobilization.png',
      explanation: 'mobilization'
    },
    {
      title: 'key_features.controls',
      style: 'thumbnails',
      image: 'key_features--controls.png',
      explanation: 'controls',
    },
    {
      title: 'key_features.comfort',
      style: 'thumbnails',
      image: 'key_features--comfort.png',
      explanation: 'comfort',
    },
  ],
  modifications: [
    {
      title: 'modifications.mattress',
      icon: 'icon-mattress',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'modifications.mattress.with_mattress',
            image: 'modifications--with_mattras.jpg',
            modelParts: [
              {
                name: 'mattress_geo',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.mattress.without_mattress',
            image: 'modifications--without_mattras.jpg',
            modelParts: [
              {
                name: 'mattress_geo',
                visible: false
              }
            ]
          }
        ]
      }
    }
  ]
}